import actions from "./actions.admin-users"
import getters from "./getters.admin-users"
import mutations from "./mutations.admin-users"

export interface AdminUser {
  id: string
  name: string | null
  email: string
  catOrganizationId: string | null
  catOrganizationName?: string | null
}

export interface AdminUsersState {
  users: AdminUser[]
  loading: boolean
  userSearch: string
  organizationSearch: string
  page: number
  itemsPerPage: number
  totalCount: number
}

export const state: AdminUsersState = {
  users: [],
  loading: false,
  userSearch: "",
  organizationSearch: "",
  page: 1,
  itemsPerPage: 10,
  totalCount: 0,
}

const AdminUsers = {
  namespaced: true as true,
  state,
  getters,
  mutations,
  actions,
}

export default AdminUsers
